import CustomZObject from './CustomZObject.js';

export default class System5 extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet("Speed", ([speed]) => this.onSpeed(speed));
        this.newInlet("Density", ([density]) => this.onDensity(density));

        this.newOutlet("Density ");
        this.newOutlet("Speed ");

        this.playhead.system5Objects.push(this);
        this.densityEffect.system5Objects.push(this);
    }

    sendSpeeds() {
        this.sendMessage("Speed ", this.playhead.speedFactorParameter.get());
    }

    sendDensities() {
        this.sendMessage("Density ", this.densityEffect.densityParameter.get());
    }

    get playhead() {
        let root = this.getRoot();
        return root.playhead;
    }

    get densityEffect() {
        let root = this.getRoot();
        return root.midiEffects.shadowEffects[0];
    }

    getRoot() {
        let sub = this.subSequence;
        while (!sub.tracks) {
            sub = sub.subSequence;
        }
        return sub;
    }

    onSpeed(speed) {
        this.playhead.speedFactorParameter.set(speed);
    }

    onDensity(density) {
        let root = this.getRoot();
        root.midiEffects.shadowEffects[0].densityParameter.set(density);
    }
}
